<script setup lang="ts">
import SmartImage from '@/components/base/common/SmartImage.vue'

interface Item {
  id: string | number
  avatar: string
  name: string
  birthYear: string | number
  deathYear: string | number
  [key: string]: any
}

const props = withDefaults(
  defineProps<{
    item: Item
    desc?: string
    public?: boolean
    nameSuffix?: string
  }>(),
  {
    nameSuffix: ''
  }
)
</script>

<template>
  <NuxtLink
    :to="`/m/${item.id}`"
    class="flex relative bg-[#F6F6F6] rounded-2 overflow-hidden p-3 active:bg-gray-200 transition-colors">
    <!-- 固定比例 3:4 图片，使用 SmartImage 防止塌陷 -->
    <div class="w-18 flex-shrink-0 relative rounded-2 overflow-hidden z-10" style="aspect-ratio: 3/4">
      <SmartImage :src="item.avatar" :aspectRatio="3 / 4" objectFit="cover" class="w-full h-full" />
    </div>
    <!-- 文本内容 -->
    <div class="ml-4 flex flex-col justify-start flex-1 gap-1.5 z-10">
      <div class="text-[17px] font-bold text-xl text-gray-800">{{ item.name }}{{ nameSuffix }}</div>
      <div class="text-[14px] text-gray-400 font-normal">{{ item.birthYear }}-{{ item.deathYear }}</div>
      <div v-if="desc" class="text-[14px] text-gray-400 font-normal">{{ desc }}</div>
    </div>

    <!-- 右侧箭头 -->
    <div class="flex items-center text-gray-400 z-10">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-[24px] w-[24px]" viewBox="0 0 20 20" fill="currentColor">
        <path
          fill-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clip-rule="evenodd" />
      </svg>
    </div>
  </NuxtLink>
</template>

<style scoped></style>
